module.exports = window["wp"]["hooks/buildTypes"];